import script from "./divider-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./divider-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./divider-setting-ly.vue?vue&type=style&index=0&id=8e92d302&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e92d302"]])

export default __exports__